import ResolutionOptions, { ResolutionOptionsStrings } from 'enums/ResolutionOptions'
import RegionOptions, { RegionOptionsStrings } from 'enums/RegionOptions'

export const getDisplayModeOption = (resolution: ResolutionOptionsStrings) => {
  switch (resolution) {
    case ResolutionOptions.COUNTRIES:
    case ResolutionOptions.STATES_PROVINCES:
    case ResolutionOptions.MARKET_AREAS:
      return 'regions'
    case ResolutionOptions.CITIES:
      return 'markers'
    default:
      throw new Error(`Unsupported Resolution: ${resolution}`)
  }
}

export const getRegionOption = (region: RegionOptionsStrings) => {
  switch (region) {
    case RegionOptions.WORLD:
      return 'world'
    case RegionOptions.NORTH_AMERICA:
      return '021'
    case RegionOptions.US:
      return 'US'
    case RegionOptions.CANADA:
      return 'CA'
    case RegionOptions.MEXICO:
      return 'MX'
    case RegionOptions.SOUTH_AMERICA:
      return '005'
    case RegionOptions.CENTRAL_AMERICA:
      return '013'
    case RegionOptions.EUROPE:
      return '150'
    case RegionOptions.AFRICA:
      return '002'
    case RegionOptions.ASIA:
      return '142'
    case RegionOptions.OCEANIA:
      return '009'
    case RegionOptions.CARIBBEAN:
      return '029'
    case RegionOptions.JAPAN:
      return 'JP'
    case RegionOptions.BRAZIL:
      return 'BR'
    case RegionOptions.GERMANY:
      return 'DE'
    case RegionOptions.UNITED_KINGDOM:
      return 'GB'
    case RegionOptions.FRANCE:
      return 'FR'
    case RegionOptions.POLAND:
      return 'PL'
    case RegionOptions.SPAIN:
      return 'ES'
    case RegionOptions.ITALY:
      return 'IT'
    case RegionOptions.RUSSIA:
      return 'RU'
    case RegionOptions.TURKEY:
      return 'TR'
    case RegionOptions.INDIA:
      return 'IN'
    case RegionOptions.CHINA:
      return 'CN'
    case RegionOptions.SOUTH_KOREA:
      return 'KR'
    case RegionOptions.INDONESIA:
      return 'ID'
    case RegionOptions.THAILAND:
      return 'TH'
    case RegionOptions.MALAYSIA:
      return 'MY'
    case RegionOptions.AUSTRALIA:
      return 'AU'
    case RegionOptions.NEW_ZEALAND:
      return 'NZ'
    default:
      throw new Error(`Unsupported Region: ${region} `)
  }
}

export const getResolutionOption = (resolution: ResolutionOptionsStrings) => {
  switch (resolution) {
    case ResolutionOptions.COUNTRIES:
      return 'countries'
    case ResolutionOptions.STATES_PROVINCES:
      return 'provinces'
    case ResolutionOptions.MARKET_AREAS:
      return 'metros' // 'metros' only supported for US
    case ResolutionOptions.CITIES:
      return 'countries'
    default:
      throw new Error(`Unsupported Resolution: ${resolution}`)
  }
}
